/**
 * Перенос `lib/src/utils/app_helpers.dart`.
 *
 * Во Flutter клавиатуру прятал платформенный канал
 * `SystemChannels.textInput.invokeMethod('TextInput.hide')`. В браузере
 * экранная клавиатура показывается, пока сфокусировано поле ввода, поэтому
 * эквивалент — снять фокус с активного элемента.
 */

/** `AppHelpers.closeKeyboard()` — убрать экранную клавиатуру. */
export function closeKeyboard(): void {
  if (typeof document === 'undefined') return;

  const active = document.activeElement as HTMLElement | null;
  // `blur` есть не у всякого `Element` (например, у SVG в старых движках).
  if (typeof active?.blur === 'function') active.blur();
}

/** Зеркало `abstract final class AppHelpers` — чтобы вызовы читались как в Dart. */
export const AppHelpers = { closeKeyboard } as const;
